export function isEnvEnabled(env) {
  if (typeof env !== "string") return false;

  const lowerCaseEnv = env.toLowerCase();
  return lowerCaseEnv.trim() !== "" && lowerCaseEnv !== "false" && lowerCaseEnv !== "0" && lowerCaseEnv !== "off" && lowerCaseEnv !== "no";
}
